import { render, staticRenderFns } from "./VerifactusFilter.vue?vue&type=template&id=4a696dec"
import script from "./VerifactusFilter.vue?vue&type=script&lang=js"
export * from "./VerifactusFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports